import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Collapse, Text, TextArea } from "~/components/ui";

interface PromptEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

export function PromptEditor({ value, onChange, placeholder, rows = 3 }: PromptEditorProps) {
  const { t } = useTranslation("admin");
  const examplePrompts = t("schemaAdmin.prompt.exampleItems", { returnObjects: true }) as string[];

  return (
    <div className="space-y-2">
      <div>
        <TextArea
          value={value ?? ""}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder ?? t("schemaAdmin.prompt.placeholder")}
          rows={rows}
          maxLength={500}
        />
        <Text tone="muted" className="block text-right text-xs">
          {(value ?? "").length} / 500
        </Text>
      </div>
      <Collapse
        size="small"
        ghost
        items={[
          {
            key: "examples",
            label: (
              <Text tone="muted" className="text-xs">
                <Lightbulb size={14} className="mr-1" />
                {t("schemaAdmin.prompt.examples")}
              </Text>
            ),
            children: (
              <ul className="list-disc list-inside text-xs text-noa-muted space-y-1 m-0 pl-0">
                {examplePrompts.map((example) => (
                  <li key={example} className="cursor-pointer hover:text-noa-link" onClick={() => onChange?.(example)}>
                    {example}
                  </li>
                ))}
              </ul>
            ),
          },
        ]}
      />
    </div>
  );
}
